import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useShowRankingsAppleMonths = (accountID, showID) =>
    useQuery({
        queryKey: [accountID, "shows", showID, "rankings", "apple", "months"],
        queryFn: () =>
            axios
                .get(`/api/${accountID}/rankings/shows/${showID}/apple/months`)
                .then((res) => res.data),
    });

export const useShowRankingsApple = (accountID, showID, month) =>
    useQuery({
        queryKey: [
            accountID,
            "shows",
            showID,
            "rankings",
            "apple",
            "months",
            month,
        ],
        queryFn: () =>
            axios
                .get(
                    `/api/${accountID}/rankings/shows/${showID}/apple/months/${month}`
                )
                .then((res) => res.data),
    });

export const useShowRankingsAppleDetail = (
    accountID,
    showID,
    iTunesID,
    iTunesCode,
    countryCode
) =>
    useQuery({
        queryKey: [
            accountID,
            "shows",
            showID,
            "rankings",
            "apple",
            "detail",
            iTunesID,
            iTunesCode,
            countryCode,
        ],
        queryFn: () =>
            axios
                .get(
                    `/api/${accountID}/rankings/shows/${showID}/apple/detail/${iTunesID}/${iTunesCode}/${countryCode}`
                )
                .then((res) => res.data),
    });

export const useShowRankingsSpotifyMonths = (accountID, showID) =>
    useQuery({
        queryKey: [accountID, "shows", showID, "rankings", "spotify", "months"],
        queryFn: () =>
            axios
                .get(
                    `/api/${accountID}/rankings/shows/${showID}/spotify/months`
                )
                .then((res) => res.data),
    });

export const useShowRankingsSpotify = (accountID, showID, month) =>
    useQuery({
        queryKey: [
            accountID,
            "shows",
            showID,
            "rankings",
            "spotify",
            "months",
            month,
        ],
        queryFn: () =>
            axios
                .get(
                    `/api/${accountID}/rankings/shows/${showID}/spotify/months/${month}`
                )
                .then((res) => res.data),
    });

export const useShowRankingsSpotifyDetail = (
    accountID,
    showID,
    spotifyID,
    chart,
    countryCode
) =>
    useQuery({
        queryKey: [
            accountID,
            "shows",
            showID,
            spotifyID,
            "rankings",
            "spotify",
            "detail",
            chart,
            countryCode,
        ],
        queryFn: () =>
            axios
                .get(
                    `/api/${accountID}/rankings/shows/${showID}/spotify/detail/${spotifyID}/${chart}/${countryCode}`
                )
                .then((res) => res.data),
    });
